<template>
    <div id="main">
        <div class="header">
            <div :class="{ expend: expend }" class="big-title">
                <div class="comp">
                    <div>
                        <div class="logo" @click="turnBack"
                             :style="{ backgroundImage: getLogoUrl() ? `url(${getLogoUrl()})` : 'none' }"></div>
                    </div>
                </div>
            </div>
            <div :class="{ expend: expend }" class="header-container">
                <div style="display: flex">
                    <div class="expend-button" @click="expend = !expend"></div>
                    <div style="display: flex;align-items: center">
                        <el-select v-model="curOrg" size="small" @change="curOrgChange">
                            <el-option v-for="(item, index) in orgList" :key="index"
                                       :label="item.code + ' - ' + item.name"
                                       :value="item.id">
                                {{ item.code }} - {{ item.name }}
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="sound" v-if="systemNotice">
                    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M257.493333 322.4l215.573334-133.056c24.981333-15.413333 57.877333-7.914667 73.493333 16.746667 5.301333 8.373333 8.106667 18.048 8.106667 27.914666v555.989334C554.666667 819.093333 530.784 842.666667 501.333333 842.666667c-9.994667 0-19.786667-2.773333-28.266666-8L257.493333 701.6H160c-41.237333 0-74.666667-33.013333-74.666667-73.738667V396.138667c0-40.725333 33.429333-73.738667 74.666667-73.738667h97.493333z"
                            fill="currentColor">
                        </path>
                    </svg>
                    <li>
                        <p class="text">{{ systemNotice }}</p>
                    </li>
                </div>
                <div>
                    <div class="toolbar">
                        <index-search :nav-list="navList"></index-search>
                        <index-download ref="indexDownload"></index-download>
                        <index-message ref="indexMessage"></index-message>
                        <el-popover placement="bottom" trigger="click">
                            <div style="padding: 4px; ">
                                <div v-for="(item, value) in langMap" :key="value"
                                     style="display: flex; flex-direction: row;">
                                    <div :style="{opacity: lang === value ? '1' : '0'}" class="arrow"></div>
                                    <div :class="{ 'lang-option': true, 'active': lang === value }"
                                         @click="toggleLang(value)">
                                        {{ item }}
                                    </div>
                                </div>
                            </div>
                            <div slot="reference" class="option font_family icon-i18n">
                                <span>{{ langMap[lang] }}</span>
                            </div>
                        </el-popover>
                        <el-popover :title="$d('用户菜单')" placement="bottom" trigger="click">
                            <div class="user-option" @click="optionsClick('editPasswords')">
                                {{ $d('修改密码') }}
                            </div>
                            <div class="user-option" @click="optionsClick('selectPrinter')">
                                {{ $d('选择打印机') }}
                            </div>
                            <div class="user-option" @click="optionsClick('clearCache')">
                                {{ $d('清除缓存') }}
                            </div>
                            <div class="user-option" @click.stop="optionsClick('appSource')">{{
                                    $d('PDA地址二维码')
                                }}
                            </div>
                            <div class="user-option" @click.stop="optionsClick('downloadResource')">{{
                                    $d('资源下载')
                                }}
                            </div>
                            <div class="user-option" @click="logout">{{ $d('退出登录') }}</div>
<!--                            <div class="user-ops-info">
                                <div>运维号码:17375131375</div>
                                <div>运维微信号:lijh1255531653</div>
                            </div>-->
                            <div slot="reference" class="name el-icon-user-solid">{{ username() }}</div>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-content">
            <index-nav ref="nav" :nav-list="navList" :expend="expend"
                       @selected="item => selectNav(item, null, true)"></index-nav>
            <div :class="{ expend: expend }" class="seat"></div>
            <div :class="{ expend }" class="page-content">
                <div v-if="$store.getters['etao/pages'].length" class="tabs">
                    <el-tabs :value="$store.getters['etao/focusPage']" class="tabs-nav" closable tab-position="top"
                             type="card"
                             @tab-click="clickTab"
                             @tab-remove="removeTab">
                        <el-tab-pane v-for="(item, index) in $store.getters['etao/pages']"
                                     :key="item.menuName"
                                     :name="item.menuName">
                            <span slot="label" style="user-select: none"
                                  @contextmenu.prevent="tabContextmenu(item, index)">
                                {{ item.menuName }}
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="page">
                    <div class="content">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>
        <e-window ref="sourceCode" title="PDA地址二维码" :destroy-on-close="false">
            <div class="source-code">
                <div ref="appDownload"></div>
                <div ref="appUrl" class="appUrl" @click="appUrlClick"></div>
            </div>
            <div class="source-title">
                <div>APK下载地址</div>
                <div>应用访问地址</div>
            </div>
        </e-window>

        <e-window ref="download" title="资源下载">
            <div style="margin-bottom: 10px">插件下载</div>
            <e-table :fields="downloadTable.field"
                     :data="downloadTable.plugin"
                     :selection="false"
                     :operation-mode="false"
                     :pagination="false">

                <template v-slot:row="{ item }">
                    <el-button type="text" size="small" @click="download(item)">{{ $d('下载') }}</el-button>
                </template>
            </e-table>
            <div style="margin: 10px 0">资料下载</div>
            <e-table :fields="downloadTable.field"
                     :data="downloadTable.document"
                     :selection="false"
                     :operation-mode="false"
                     :pagination="false">

                <template v-slot:row="{ item }">
                    <el-button type="text" size="small" @click="download(item)">{{ $d('下载') }}</el-button>
                </template>
            </e-table>
        </e-window>
        <etao-dialog
            ref="password"
            :is-footer="true"
            :title="$d('修改密码')"
            @submitForm="() => $refs.child.submitForm()" height="300" width="30%">
            <edit-password @close="$refs.child.closeDialog()" ref="child"/>
        </etao-dialog>
        <e-window ref="printerWin" :title="$d('选择打印机')">
            <select-printer ref="printer"></select-printer>
        </e-window>

        <etao-dialog-no-close
            ref="passwordNoClose"
            :is-footer="true"
            :title="this.$route.query.passwordValid === 'false' ? $d('首次登录必须修改密码') : $d('当前密码安全性弱,请修改密码')"
            @submitForm="() => $refs.child.submitForm()" height="300" width="50%">
            <edit-password @close="closePassword" ref="child"/>
        </etao-dialog-no-close>

        <chat-bot avatar="" :username="username()"/>
    </div>
</template>

<script>
import chatBot from '@/components/index/chatBot'
import indexApp from '@/components/index/indexApp'
import indexNav from '@/components/index/indexNav'
import indexMessage from '@/components/index/indexMessage'
import indexDownload from '@/components/index/indexDownload'
import indexSearch from '@/components/index/indexSearch'
import download from '@/components/index/data/download'
import pinyin from 'pinyin'
import {CacheData} from 'etao-component-sp'
import {CURRENT_ORG_CODE_KEY, CURRENT_ORG_KEY} from '@/components/login/secret'
import EtaoDialog from '@/comp/etao-dialog'
import EtaoDialogNoClose from '@/comp/etao-dialog-no-close'
import EditPassword from '@/components/index/edit-password'
import SelectPrinter from '@/components/index/select-printer'
import Common from '@/comp/form/common'
import eventBus from '@/comp/lib/eventBus'

export default {
    name: 'Main',
    components: {
        EditPassword,
        EtaoDialog,
        EtaoDialogNoClose,
        chatBot,
        indexApp,
        indexNav,
        indexSearch,
        indexMessage,
        indexDownload,
        SelectPrinter
    },
    watch: {
        curOrg (val) {
            localStorage.setItem(CURRENT_ORG_KEY, val)
            if (this.orgList && this.orgList.length > 0) {
                let orgMap = Common.listTransToOptions(this.orgList, 'id', 'code')
                localStorage.setItem(CURRENT_ORG_CODE_KEY, orgMap[val])
            }
        },
        curOrgCode (val) {
            localStorage.setItem(CURRENT_ORG_CODE_KEY, val)
        }
    },
    methods: {
        closePassword () {
            this.$refs.passwordNoClose.closeDialog()
            this.logout()
        },
        appUrlClick () {
            window.open(window.location.origin + '/app/pda', '_blank')
        },
        tabContextmenu: function (item, index) {
            this.$contextmenu({
                items: [
                    {
                        label: '关闭',
                        onClick: () => {
                            this.$store.commit('etao/removePage', item.name)
                        }
                    },
                    {
                        label: '关闭左侧',
                        disabled: index === 0,
                        onClick: () => {
                            this.$store.commit('etao/removeLeftPages', item.name)
                        }
                    },
                    {
                        label: '关闭右侧',
                        disabled: index >= this.$store.getters['etao/pages'].length - 1,
                        onClick: () => {
                            this.$store.commit('etao/removeRightPages', item.name)
                        }
                    },
                    {
                        label: '关闭其他',
                        disabled: this.$store.getters['etao/pages'].length <= 1,
                        onClick: () => {
                            this.$store.commit('etao/removeOtherPages', item)
                        }
                    },
                    {
                        label: '关闭全部',
                        onClick: () => {
                            this.$store.commit('etao/removeAllPages')
                            this.turnBack()
                        }
                    }
                ],
                event,
                zIndex: 10000,
                minWidth: 110
            })
        },
        getMenu: function () {
            this.etao.requests.get({
                url: '/etao-system/menu/routes',
                data: {
                    clientType: 'PC'
                },
                successMessage: false,
                success: res => {
                    const map = {}
                    const operateMap = {}
                    const buildMap = function (data, parentCode = '') {
                        if (!(data instanceof Array)) {
                            return
                        }
                        for (let item of data) {
                            item.route = item.path

                            item.menuName = item.name
                            item.menuCode = item.code
                            item.menuType = item.category

                            item.menuNamePinyin = pinyin(item.menuName, {
                                segment: false,
                                group: false,
                                style: pinyin.STYLE_FIRST_LETTER
                            }).join('').toUpperCase()

                            if (item.category === 'O') {
                                let operate = operateMap[parentCode] || []
                                operate.push(item.code)
                                operateMap[parentCode] = operate
                            }

                            map[item.route] = item
                            if (item.children && item.children.length) {
                                buildMap(item.children, item.code)
                            }
                        }
                    }
                    buildMap(res.data)

                    this.$set(this, 'navList', res.data)
                    this.$store.commit('etao/setNavList', res.data)
                    this.$store.commit('etao/setRouteMap', map)

                    this.etao.common.saveData('operateMap', operateMap)

                    setTimeout(() => {
                        // 有概率 $route.path 为根路由，延时读取
                        if (this.$route.path in map) {
                            this.selectNav(map[this.$route.path])
                        }
                    }, 200)
                }
            })
        },
        selectNav: function (item) {
            const code = item.menuCode
            const navLog = this.etao.common.getData('navLog') || {}

            if (navLog['lastVisit'] === undefined) {
                navLog['lastVisit'] = {}
            }
            if (navLog['history'] === undefined) {
                navLog['history'] = []
            }
            navLog['lastVisit'][code] = item
            navLog['history'].unshift(item)
            navLog['history'] = navLog['history'].slice(0, 10)

            this.$router.push({path: item.route})
            this.$store.commit('etao/setPage', item)
            this.etao.common.saveData('navLog', navLog)
        },
        optionsClick: function (command) {
            this.showOptions = false

            switch (command) {
                case 'appSource':
                    this.$refs.sourceCode.show()
                    // this.loadStatus = true
                    this.$nextTick(() => {
                        const host = window.location.origin
                        this.etao.common.createQRCode(this.$refs.appDownload, host + '/static/print_plugin/etao_app.apk')
                        this.etao.common.createQRCode(this.$refs.appUrl, host + '/app/pda')
                    })
                    break
                case 'downloadResource':
                    this.$refs.download.show()
                    break
                case 'editPasswords':
                    this.$refs.password.openDialog()
                    break
                case 'selectPrinter':
                    this.$refs.printerWin.show()
                    this.$nextTick(() => {
                        this.$refs.printer.setTemplateId(this.category)
                    })
                    break
                case 'clearCache':
                    this.clearCache()
                    break
                case 'logout':
                    this.logout()
                    break
            }
        },
        editPasswords: function () {
            let password = this.password.newPassword
            let surePassword = this.password.repeatNewPassword
            const isComplex = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}/.test(password)
            if (!isComplex) {
                // 密码复杂度不足,至少包含大写字母、小写字母、数字，且长度至少8位
                this.etao.message.toast(this.$d('密码复杂度不足，至少包含大写字母、小写字母、数字，且长度至少8位'), 'error')
                return
            }
            if (password !== surePassword) {
                this.etao.message.toast(this.$d('两次新密码不一致'), 'error')
                return
            }
            this.etao.requests.post({
                url: '/etao-system/user/update-password',
                data: this.password,
                success: res => {
                    return this.etao.message.alert(res.msg, '提示', () => {
                        this.$refs.password.hide()
                        this.logout()
                    })
                }
            })
        },
        download: function (item) {
            location.href = item.url
        },
        turnBack: function () {
            this.expend = false
            this.$router.push({path: '/index'})
        },
        logout: function () {
            console.log('doLoginOut')
            this.etao.common.removeData('token')
            this.etao.common.removeData('refreshToken')
            this.etao.common.removeData('userInfo')
            localStorage.removeItem(CURRENT_ORG_KEY)
            localStorage.removeItem(CURRENT_ORG_CODE_KEY)
            this.etao.common.removeData('curOrg')
            this.$router.push({path: '/login'})
        },
        removeTab: function (name) {
            const closedPage = this.$store.getters['etao/pages'].find(page => page.menuName === name)
            this.$store.commit('etao/removePage', name)
            if (closedPage && closedPage.route) {
                eventBus.$emit('tab-closed', closedPage.route)
            }
        },
        clickTab: function (tab) {
            this.selectNav(this.$store.getters['etao/pages'][tab.index])
        },
        username: function () {
            const user = this.etao.common.getData('userInfo')
            if (user) {
                return user['name']
            }
        },
        curOrgChange: function () {
            this.refreshRoute()
        },
        toggleLang: function (lang) {
            this.lang = lang
            this.$i18n.locale = this.lang
            this.etao.common.saveData('lang', this.lang)
            this.refreshRoute()
        },
        getOrgList: function (callback) {
            this.etao.requests.get({
                url: '/etao-system/organization/select-all',
                successMessage: false,
                success: (res) => {
                    this.$set(this, 'orgList', res.data)
                    if (res.data && res.data.length > 0 && !localStorage.getItem(CURRENT_ORG_KEY)) {
                        this.$set(this, 'curOrg', res.data[0].id)
                        this.$set(this, 'curOrgCode', res.data[0].code)
                        // 保存到localStorage
                        localStorage.setItem(CURRENT_ORG_KEY, res.data[0].id)
                        localStorage.setItem(CURRENT_ORG_CODE_KEY, res.data[0].code)
                    } else {
                        this.$set(this, 'curOrg', localStorage.getItem(CURRENT_ORG_KEY))
                        this.$set(this, 'curOrgCode', localStorage.getItem(CURRENT_ORG_CODE_KEY))
                    }
                    // 在组织信息设置完成后获取语言列表
                    this.getLangMap()
                    // 如果有回调函数，执行回调（用于确保组织信息设置完成后再执行其他操作）
                    if (callback && typeof callback === 'function') {
                        callback()
                    }
                }
            })
        },
        clearCache () {
            let $this = this
            this.$confirm('是否需要清除缓存?', '清除缓存', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                CacheData.clear()
                $this.etao.requests.get({
                    url: '/etao-auth/oauth/clear-cache',
                    authorization: false,
                    success: res => {
                    }
                })
            })
        },
        refreshRoute () {
            this.$router.go(0)
        },
        checkIsFirst () {
            let userInfoObj = this.etao.common.getData('userInfo')
            // 供应商初次登录必须要修改密码
            if (userInfoObj && userInfoObj.isFirst === 1 && userInfoObj.userType === 3) {
                // if (userInfoObj && userInfoObj.isFirst === 1) {
                // this.optionsClick('editPasswords')
                this.$refs.passwordNoClose.openDialog()
            }
        },
        // 连接到WebSocket服务器
        connectWebsocket () {
            let that = this
            // 获取当前用户
            const user = this.etao.common.getData('userInfo')
            console.log('开始连接WebSocket服务器')
            if (!this.websocket) {
                this.websocket = new WebSocket('ws://' + this.webSocketIp + '/ws/connect?client_type=PC&user_id=' + user.userId)
            }
            this.websocket.onopen = () => {
                console.log('WebSocket连接成功')
                console.log('开始拉取未发送的消息')
                this.etao.requests.post({
                    url: '/etao-resource/unified-message/pull-unsent-message/' + user.userId,
                    successMessage: false,
                    success: res => {
                    }
                })
            }

            this.websocket.onmessage = function (event) {
                if (event.data === 'pong') {
                    return
                }
                console.log('收到消息：', event.data)
                const data = JSON.parse(event.data)
                // 自定义业务类型执行逻辑
                switch (data.businessType) {
                    case 'message_notice':
                        // 刷新站内消息（refreshMessages内部已经调用了getMineUnread和getUnreadNoticeCount）
                        if (that.$refs.indexMessage) {
                            that.$refs.indexMessage.refreshMessages()
                        }
                        break
                    case 'system_notice': // 系统公告处理
                        that.systemNotice = data.message
                        // 刷新消息列表（refreshMessages内部已经调用了getMineUnread和getUnreadNoticeCount）
                        if (that.$refs.indexMessage) {
                            that.$refs.indexMessage.refreshMessages()
                        }
                        // 一分钟后清除通知
                        setTimeout(() => {
                            that.systemNotice = ''
                        }, 60000) // 60秒 = 1分钟
                        break
                    case 'refresh_task_progress':
                        let indexDownload = that.$refs.indexDownload
                        if (indexDownload) {
                            indexDownload.refreshProgress(JSON.parse(data.message))
                        }
                        break
                }
                if (data.businessType !== 'refresh_task_progress') {
                    that.etao.message.notify(data.message, data.title)
                }
            }

            this.websocket.onclose = function () {
                console.log('WebSocket连接关闭')
            }
            window.onbeforeunload = function () {
                this.websocket && this.websocket.close()
            }

            // 每隔30s发送一次心跳
            setInterval(() => {
                if (this.websocket.readyState === 1) {
                    this.websocket.send('heartbeat')
                }
            }, 30000)
        },
        closeWebSocket () {
            this.websocket && this.websocket.close()
        },
        getLogoUrl () {
            let tenant = this.etao.common.getData('tenantInfo')
            return tenant ? this.etao.common.getData('tenantInfo').logoUrl : null
        },
        getLangMap: function () {
            this.etao.requests.get({
                url: '/etao-system/i18n/list-code',
                successMessage: false,
                success: res => {
                    this.$set(this, 'langMap', Common.listTransToOptions(res.data, 'langCode', 'langType'))
                }
            })
        }
    },
    data () {
        return {
            systemNotice: '',
            category: 'LODOP',
            loadStatus: false,
            showOptions: false,
            expend: true,
            navList: [],
            password: {
                password: '',
                newPassword: '',
                repeatNewPassword: ''
            },
            lang: 'zh_CN',
            langMap: {}, // 初始化为空对象
            downloadTable: download,
            orgList: [],
            curOrg: '',
            curOrgCode: '',
            webSocket: null
        }
    },
    mounted () {
        window.logout = this.logout
        window.turnBack = this.turnBack
        window.selectNav = this.selectNav

        if (this.$route.query.passwordValid === 'false') {
            this.$refs.passwordNoClose.openDialog()
        }

        this.lang = this.etao.common.getData('lang') || 'zh_CN'

        const user = this.etao.common.getData('userInfo')
        if (!user) {
            this.getMenu()
            this.getLangMap() // 没有用户信息时直接获取语言列表
        } else {
            // 先获取组织信息，在组织信息设置完成后再获取菜单路由
            this.getOrgList(() => {
                // 组织信息获取完成后，再获取菜单路由，确保携带组织ID
                this.getMenu()
            })
        }
        this.connectWebsocket()
        this.checkIsFirst()
        window.i18n = this.$i18n

        window.openNav = () => {
            this.expend = true
        }
    },
    beforeDestroy () {
        this.closeWebSocket()
    }
}
</script>

<style scoped src="./css/index.css"></style>
<style src="./css/order.css"></style>
<style>
.page-content > .page > .content > * {
    width: 100%;
    height: 100%;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
    display: flex;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
    display: flex;
    align-items: center;
}

.user-option {
    cursor: pointer;
}

.user-ops-info {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #ebeef5;
    color: #606266;
    font-size: 12px;
    line-height: 20px;
    cursor: default;
    user-select: text;
}

.lang-option {
    padding: 1px 0;
    line-height: 22px;
    cursor: pointer;
}

.lang-option:hover {
    color: #5F49E6;
    font-weight: bold;
}

.user-option:hover {
    color: #5F49E6;
    text-decoration: underline;
}

.arrow {
    display: inline-block;
    margin-right: 8px;
    border-top: 8px solid #ccc;
    border-right: 4px solid transparent;
    border-bottom: 0;
    border-left: 4px solid transparent;
    vertical-align: middle;
    opacity: 0;
    transform: translateY(0px) rotate(-90deg);
    transition: all .3s;
}

.active {
    color: #5F49E6;
    font-weight: bold;
}

.page-content > .tabs .el-tabs__header {
    margin: 0;
}

.page-content > .tabs .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none !important;
}

.page-content > .tabs .el-tabs--card > .el-tabs__header .el-tabs__item {
    color: #111111;
    background: #E6E6E6;
    font-weight: normal;
    box-shadow: none;
}

.page-content > .tabs .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #5F49E6;
}

.last-breadcrumb > span {
    color: #201E1E !important;
}

.menu_item__available:hover {
    color: #5F49E6 !important;
    background: rgba(95, 73, 230, 0.15) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue